// extracted by mini-css-extract-plugin
module.exports = {"mainSidebar":"Sidebar_mainSidebar__3FT_v","logo":"Sidebar_logo__1hpy4","navLink":"Sidebar_navLink__1A5Mn","sideIcon":"Sidebar_sideIcon__Kd24F"};